/* wd-menus.js — WonderGifts India menu interactions
 * Reference: menu-implementation-spec.md §6
 *
 * Three concerns: desktop mega-menu hover, mobile drawer toggle, drawer
 * accordion. All HTML is server-rendered; JS only toggles classes.
 *
 * Targets <5KB minified.
 */
(function () {
  'use strict';

  // ---- Desktop mega menu ---------------------------------------------------
  // Hover a nav item with [data-mega] -> show its panel.
  // 200ms grace period prevents flicker when crossing trigger -> panel.

  var GRACE_MS = 200;
  var closeTimer = null;
  var mega = document.querySelector('[data-wd-mega]');
  var navItems = document.querySelectorAll('.wd-nav__item[data-mega]');

  // Debug breadcrumb in console — remove once verified.
  if (window.console && console.log) {
    console.log('[wd-menus] init — navItems:', navItems.length, 'mega container:', !!mega);
  }

  // ---- Measure header height -> CSS var so the fixed-position mega knows
  //      where to anchor itself just below the header.
  function updateHeaderBottom() {
    var header = document.querySelector('.wd-header');
    if (!header) return;
    var rect = header.getBoundingClientRect();
    // bottom relative to viewport top (handles sticky perfectly)
    var bottom = Math.max(0, rect.bottom);
    document.documentElement.style.setProperty('--wd-header-bottom', bottom + 'px');
  }

  updateHeaderBottom();
  window.addEventListener('resize', updateHeaderBottom);
  window.addEventListener('scroll', updateHeaderBottom, { passive: true });

  // ---- Hero slideshow -----------------------------------------------------
  // Each .wd-hero element auto-rotates its .wd-hero__slide children. Manual
  // navigation via .wd-hero__arrow and .wd-hero__dot. Pauses on hover.
  var heroes = document.querySelectorAll('[data-wd-hero]');
  if (window.console && console.log) {
    console.log('[wd-menus] heroes found:', heroes.length);
  }
  for (var h = 0; h < heroes.length; h++) {
    initHero(heroes[h]);
  }

  function initHero(hero) {
    var slides = hero.querySelectorAll('[data-wd-hero-slide]');
    var dots = hero.querySelectorAll('[data-wd-hero-dot]');
    var prevBtn = hero.querySelector('[data-wd-hero-prev]');
    var nextBtn = hero.querySelector('[data-wd-hero-next]');
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    if (window.console && console.log) {
      console.log('[wd-menus] initHero — slides:', slides.length,
                  'dots:', dots.length,
                  'prev:', !!prevBtn, 'next:', !!nextBtn,
                  'autoplay:', autoplay);
    }
    if (slides.length <= 1) return;

    var current = 0;
    var seconds = parseInt(hero.getAttribute('data-autoplay-seconds') || '6', 10);
    var timer = null;

    function show(idx) {
      idx = ((idx % slides.length) + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('wd-is-active', i === idx);
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('wd-is-active', j === idx);
        dots[j].setAttribute('aria-selected', j === idx ? 'true' : 'false');
      }
      current = idx;
    }

    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(next, seconds * 1000);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });

    for (var d = 0; d < dots.length; d++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () { show(idx); start(); });
      })(d);
    }

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    start();
  }

  function openPanel(panelName) {
    if (!mega) return;
    var panels = mega.querySelectorAll('.wd-mega__panel');
    for (var i = 0; i < panels.length; i++) {
      panels[i].classList.toggle('wd-is-active', panels[i].getAttribute('data-panel') === panelName);
    }
    mega.classList.add('wd-is-open');
    for (var j = 0; j < navItems.length; j++) {
      navItems[j].classList.toggle('wd-is-active', navItems[j].getAttribute('data-mega') === panelName);
    }
  }

  function closeMega() {
    if (!mega) return;
    mega.classList.remove('wd-is-open');
    for (var i = 0; i < navItems.length; i++) {
      navItems[i].classList.remove('wd-is-active');
    }
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMega, GRACE_MS);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  for (var k = 0; k < navItems.length; k++) {
    var item = navItems[k];
    var name = item.getAttribute('data-mega');
    (function (panelName) {
      item.addEventListener('mouseenter', function () {
        cancelClose();
        openPanel(panelName);
      });
      item.addEventListener('mouseleave', scheduleClose);
    })(name);
  }

  if (mega) {
    mega.addEventListener('mouseenter', cancelClose);
    mega.addEventListener('mouseleave', scheduleClose);
  }

  // ---- Explore side-rail (swap pane on rail-item hover) --------------------
  var railItems = document.querySelectorAll('[data-wd-rail-item]');
  for (var r = 0; r < railItems.length; r++) {
    (function (railItem) {
      railItem.addEventListener('mouseenter', function () {
        var paneName = railItem.getAttribute('data-wd-rail-item');
        var rail = railItem.closest('[data-wd-rail]');
        if (!rail) return;
        var siblings = rail.querySelectorAll('[data-wd-rail-item]');
        for (var s = 0; s < siblings.length; s++) {
          siblings[s].classList.toggle('wd-is-active', siblings[s] === railItem);
        }
        var panel = railItem.closest('.wd-mega__panel');
        if (!panel) return;
        var panes = panel.querySelectorAll('[data-wd-rail-pane]');
        for (var p = 0; p < panes.length; p++) {
          panes[p].classList.toggle('wd-is-active', panes[p].getAttribute('data-wd-rail-pane') === paneName);
        }
      });
    })(railItems[r]);
  }

  // ---- Mobile drawer toggle ------------------------------------------------
  var drawer = document.querySelector('[data-wd-drawer]');
  var overlay = document.querySelector('[data-wd-drawer-overlay]');
  var hamburger = document.querySelector('[data-wd-hamburger]');
  var closeBtn = document.querySelector('[data-wd-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('wd-is-open');
    if (overlay) overlay.classList.add('wd-is-visible');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('wd-is-open');
    if (overlay) overlay.classList.remove('wd-is-visible');
    document.documentElement.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // ---- Drawer accordion (only one section open at a time) ------------------
  var sectionToggles = document.querySelectorAll('[data-wd-drawer-section-toggle]');
  for (var t = 0; t < sectionToggles.length; t++) {
    (function (toggle) {
      toggle.addEventListener('click', function () {
        var section = toggle.closest('[data-wd-drawer-section]');
        if (!section) return;
        var wasOpen = section.classList.contains('wd-is-open');
        var allSections = document.querySelectorAll('[data-wd-drawer-section]');
        for (var a = 0; a < allSections.length; a++) {
          allSections[a].classList.remove('wd-is-open');
        }
        if (!wasOpen) section.classList.add('wd-is-open');
      });
    })(sectionToggles[t]);
  }

  // L2 toggles inside drawer "Shop by Category" section.
  var l2Toggles = document.querySelectorAll('[data-wd-drawer-l2-toggle]');
  for (var l = 0; l < l2Toggles.length; l++) {
    (function (toggle) {
      toggle.addEventListener('click', function () {
        var l2 = toggle.closest('[data-wd-drawer-l2]');
        if (!l2) return;
        var parent = l2.parentElement;
        var wasOpen = l2.classList.contains('wd-is-open');
        var siblings = parent.querySelectorAll('[data-wd-drawer-l2]');
        for (var s = 0; s < siblings.length; s++) {
          siblings[s].classList.remove('wd-is-open');
        }
        if (!wasOpen) l2.classList.add('wd-is-open');
      });
    })(l2Toggles[l]);
  }
})();
